


















import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {
  }
})
export default class Tips extends Vue{
  @Prop() title!: string;
  @Prop() content!: string;
  @Prop() type!: string;

  handleShowTips() {
    Vue.$confirm({
      oneBtn: true,
      title: this.title,
      text: this.content,
      classname: 'text-align-left'
    })
  }
}
